import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Gleichstellung",
  "lead": "Weltweit sind Fortschritte bei der Gleichstellung der Geschlechter im Bildungsbereich erkennbar, doch bestehen nach wie vor erhebliche Unterschiede zwischen ländlichen und städtischen Gebieten sowie zwischen reichen und armen Bevölkerungsgruppen."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_EQUITY"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Der Anspruch, niemanden zurückzulassen, zieht sich durch die Ziele für nachhaltige Entwicklung (SDGs) und ist besonders im fünften Unterziel des Bildungsziels des SDG 4 klar verankert. Dies stellt sicher, dass politische Entscheidungsträger in erster Linie den am stärksten benachteiligten Personen Unterstützung zukommen lassen."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Um überwachen zu können, ob Bildungslücken geschlossen werden, benötigen wir Daten, die nach ", _jsx(_components.strong, {
        children: "Einkommen, Geschlecht, Alter, Ethnie, Migrationsstatus, körperlicher Einschränkungen, geografischer Lage und anderen  für den nationalen Kontextrelevanten Merkmalen"
      }), " aufgeschlüsselt sind ."]
    }), "\n", _jsxs(_components.p, {
      children: ["Seit 2010zeigtdie ", _jsx(_components.a, {
        href: "https://www.education-inequalities.org/",
        children: "World Inequality Database on Education"
      }), "anhand von Haushaltserhebungen, wie groß die Bildungsunterschiede in verschiedenen Ländern sind. Dieser Artikel fasst einige der wichtigsten Fakten und Trends zur Ungleichheit im Bildungswesen zusammen, während einige zusätzliche Aspekte in dem Artikel über ", _jsx(PageLink, {
        name: "finance",
        children: "Finanzen"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "geschlecht",
      children: "Geschlecht"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.1",
      children: [_jsxs(_components.p, {
        children: ["Die nachstehenden Schaubilder zeigen die Bildungsunterschiede zwischen verschiedenen Gruppen, z. B. zwischen Mädchen und Jungen oder zwischen den Ärmsten und den Reichsten. Er misst dieses Bildungsgefälle mit einem ", _jsx(Tooltip, {
          title: "Paritätsindex",
          content: "Bei einem Paritätsindex zeigt ein Wert nahe 0, dass die benachteiligte Gruppe sehr weit zurückliegt; Werte nahe 1 bedeuten, dass Gleichheit besteht; Werte nahe 2 bedeuten, dass die begünstigte Gruppe am weitesten zurückliegt. Ein Paritätsindex von 0,5 könnte beispielsweise darauf hinweisen, dass 30 % der eingeschriebenen Schülerinnen und Schüler Mädchen sind, während 60 % Jungen eingeschrieben sind. Ein Paritätsindex von 1,5 würde bedeuten, dass 30 % der Jungen, aber 60 % der Mädchen eingeschrieben sind.",
          children: "Paritätsindex"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["Auch wenn dies selten gewürdigt wird, hat es  in der letzten Generationeine kontinuierliche Entwicklung in Richtung ", _jsx(Tooltip, {
          title: "Geschlechterparität",
          content: "Wenn die Zahl der Jungen gleich der der Mädchen ist",
          children: "Geschlechterparität"
        }), " gegeben. In vielen, meist reicheren Teilen der Welt gibt es mehr Mädchen und junge Frauen als Jungen und junge Männer in Schulen und Universitäten."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GPITREND"
          })
        }), _jsx(ScrollySection, {
          id: "income,0",
          children: _jsxs(_components.p, {
            children: ["Jede Linie, die unterhalb des ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "grau schattierten"
            }), " Bereichs fällt, zeigt, dass mehr Jungen oder junge Männer als Mädchen eingeschrieben sind."]
          })
        }), _jsx(ScrollySection, {
          id: "geo,1",
          children: _jsxs(_components.p, {
            children: ["In den Ländern", _jsx(HighlightByIndex, {
              index: "0",
              children: "Subsahara Afrikas"
            }), " kommen immer noch weniger als vier junge Frauen auf fünf junge Männer, die eine tertiäre Ausbildung absolvieren."]
          })
        }), _jsx(ScrollySection, {
          id: "geo,2",
          children: _jsxs(_components.p, {
            children: [_jsx(HighlightByIndex, {
              index: "2",
              children: "Zentral- und Südasien"
            }), " hat\nvon einem extremen Rückstand der Mädchen im Jahr 1990 zu einer Geschlechterparität in der Grundschul- und Hochschulbildung,\nvor allem dank der dramatischen Fortschritte in Indien erreicht. Infolgedessen hat die Region die Länder ", _jsx(HighlightByIndex, {
              index: "0",
              children: "Subsahara Afrikas"
            }), " bei der Verwirklichung der Geschlechterparität überholt."]
          })
        })]
      }), _jsx(_components.p, {
        children: "Weltweit wurden seit dem Jahr 2000 erhebliche Fortschritte erzielt. Auf Länderebene zeigen sich jedoch weiterhin deutliche Unterschiede: Nur zwei von drei Ländern haben die Geschlechterparität bei der Einschulung in der Primarstufe erreicht, weniger als die Hälfte in der unteren Sekundarstufe und nur eines von fünf in der oberen Sekundarstufe."
      }), _jsxs(_components.p, {
        children: ["Der Anteil der Länder mit einem ", _jsx(HighlightByIndex, {
          index: "2",
          children: "großen Gefälle zu Lasten der Mädchen"
        }), " hat sich seit 2000 in der Primär- bis zur Tertiärbildung mindestens halbiert, beträgt aber immer noch 3 % in der Primarstufe, 6 % in der unteren Sekundarstufe und 12 % in der oberen Sekundarstufe."]
      }), _jsxs(_components.p, {
        children: ["Es ist wichtig, auch die Jungen nicht zu vergessen, wenn wir über die Gleichstellung der Geschlechter sprechen. Es ist zwar weniger üblich, dass Länder ein ", _jsx(HighlightByIndex, {
          index: "0",
          children: "großes Gefälle zu Lasten der Jungen"
        }), " in der Primarstufe aufweisen, da dies eher in der Sekundarstufe II und darüber hinaus festzustellen ist."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PARITYCOUNT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Je größer und dunkler der blaue Teil des Balkens in diesem Diagramm ist, desto mehr Länder gibt es mit ", _jsx(HighlightByIndex, {
              index: "0",
              children: "mehr Jungen außerhalb der Schule"
            }), " als Mädchen. Je größer und dunkler der grüne Teil des Balkens ist, desto mehr Länder gibt es mit ", _jsx(HighlightByIndex, {
              index: "2",
              children: "mehr Mädchen außerhalb der Schule"
            }), " als Jungen."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Im tertiären Bildungsbereich zum Beispiel weisen fast zwei Drittel der Länder ", _jsx(HighlightByIndex, {
              index: "0",
              children: "extreme Ungleichheiten zu Lasten der Jungen auf"
            }), "."]
          })
        })]
      }), _jsx(_components.h2, {
        id: "reichtum",
        children: "Reichtum"
      }), _jsx(_components.p, {
        children: "Insgesamt sind die Bildungsunterschiede zwischen Mädchen und Jungen zwar vorhanden, aber nicht so ausgeprägt wie die zwischen ländlichen und städtischen Gebieten oder zwischen reichen und armen Bevölkerungsgruppen. Diese Unterschiede werden besonders deutlich, wenn man Haushaltserhebungen berücksichtigt."
      }), _jsxs(_components.p, {
        children: ["In Bangladesch zum Beispiel, wo 92 % der reichsten Bevölkerung ", _jsx(HighlightByIndex, {
          index: "0"
        }), " die Grundschule abschließen, dies nur 70 % der ", _jsx(HighlightByIndex, {
          index: "1",
          children: "ärmsten Bevölkerung "
        }), " tut. In Nigeria schließen 94 % der reichsten Menschen die Sekundarstufe I ab, jedoch nur 27 % der Ärmsten."]
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "PSECWGAP"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Die roten Punkte zeigen, wie viel Prozent der ", _jsx(HighlightByIndex, {
              index: "1",
              children: "ärmsten"
            }), " kinder oder Jugendlichen die Schule im Vergleich zu den ", _jsx(HighlightByIndex, {
              index: "0",
              children: "reichsten"
            }), "besuchen (in blau angezeigt). Das Bildungsniveau kann von der Grundschule bis zur unteren Sekundarstufe und darüber hinaus oben in der Tabelle angepasst werden."]
          })
        }), _jsx(ScrollySection, {
          id: "SRB",
          children: _jsxs(_components.p, {
            children: ["Die größten Unterschiede im tertiären Bildungsbereich finden sich in den Ländern mit mittlerem Einkommen. In ", _jsx(_components.strong, {
              children: "Serbien"
            }), " zum Beispiel nahmen 77 % der wohlhabendsten, jedoch weniger als 28 % der ärmsten Menschen an irgendeiner Form der postsekundären Bildung teil."]
          })
        }), _jsx(ScrollySection, {
          id: "COL",
          children: _jsxs(_components.p, {
            children: ["In ", _jsx(_components.strong, {
              children: "Kolumbien"
            }), " betrugen die entsprechenden Anteile 64 % und 7 %."]
          })
        })]
      }), _jsx(_components.p, {
        children: "Noch aufschlussreicher ist es, zu sehen, wie sich die Unterschiede im Laufe der Ausbildung der Kinder verändern."
      }), _jsxs(_components.p, {
        children: ["Betrachtet man die ", _jsx(_components.strong, {
          children: "Geschlechtsunterschiede"
        }), " in ", _jsx(HighlightByIndex, {
          index: "0",
          children: "Benin"
        }), ", so stellt man fest, bis zu welchem Grad Mädchen die höhere Bildung abbrechen."]
      }), _jsxs(_components.p, {
        children: ["Alternativ zeigt die Auswahl ", _jsx(_components.strong, {
          children: "Reich"
        }), ", wie stark sich die Unterschiede im Verlauf der Bildungslaufbahn zugunsten der Wohlhabenden ansammeln, während kaum jemand aus den ärmsten Bevölkerungsgruppen die obere Sekundarstufe erreicht."]
      }), _jsx(Figure, {
        id: "WLGPI"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Selten lässt sich ein Kind in nur eine Kategorie einordnen. Daher ist es entscheidend, auch die Wechselwirkungen zwischen individuellen Merkmalen wie Geschlecht und anderen Faktoren wie Wohlstand zu berücksichtigen, wie in der folgenden Abbildung veranschaulicht."
    }), "\n", _jsxs(_components.p, {
      children: ["In den Ländern Subsahara Afrikas nimmt die Kluft zwischen den ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Ärmsten"
      }), " und ", _jsx(HighlightByIndex, {
        index: "0",
        children: " Reichsten"
      }), " Mädchen im Laufe der Bildungslaufbahn zu. Wobei auf 100 Jungen weniger als 35 der ärmsten Mädchen kommen, und es bei den reichsten fast 100 sind, die eine tertiäre Ausbildung absolvieren."]
    }), "\n", _jsx(_components.p, {
      children: "In Ost- und Südostasien hingegen verlaufen die Punkte von der grauen Linie nach oben, da die geschlechtsspezifischen Unterschiede vor allem zulasten der ärmsten Jungen gehen. Bei den reichsten Mädchen ist die Wahrscheinlichkeit, dass sie eine Hochschule besuchen, nur etwa 35 % höher als bei ihren männlichen Altersgenossen, während sie bei den ärmsten Mädchen 50 % höher ist."
    }), "\n", _jsx(Figure, {
      id: "GPIBYWEALTH"
    }), "\n", _jsx(_components.h2, {
      id: "schlussfolgerung",
      children: "Schlussfolgerung"
    }), "\n", _jsx(_components.p, {
      children: "Das Bildungsgefälle zwischen den Ländern und innerhalb der Länder zwischen verschiedenen Gruppen ist inakzeptabel groß. Qualitativ hochwertige, aufgeschlüsselte Daten sind entscheidend, um geeignete Strategien zur Verringerung dieser Ungleichheiten zu entwickeln und letztlich das Unterziel in SDG 4 zu erreichen."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-inequalities.org/",
            children: "Worldwide Inequalities Database on Education (WIDE)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024genderreport",
            children: "Technology on her terms – GEM Gender Report 2024"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.savethechildren.org.uk/content/dam/gb/reports/policy/still-left-behind-low-res.pdf",
            children: "Still left behind – Save the Children"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
